import { ConfirmationDialog, ConfirmationDialogProps } from './ConfirmationDialog';

export type AlertDialogProps = Omit<ConfirmationDialogProps, 'displayCancelButton' | 'cancelButtonLabel'>;

export function AlertDialog(props: AlertDialogProps) {
  return <ConfirmationDialog {...props} displayCancelButton={false} />;
}
